import { render, staticRenderFns } from "./emptyTips.vue?vue&type=template&id=5b1687c1"
import script from "./emptyTips.vue?vue&type=script&lang=js"
export * from "./emptyTips.vue?vue&type=script&lang=js"
import style0 from "./emptyTips.vue?vue&type=style&index=0&id=5b1687c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports